export function formatEventDateRange(startDate: string | undefined, endDate: string | undefined) {
    // Parse strings like "2025.08.01" and "2026.02.28"
    
    const parseDate = (dateStr: string | undefined) => {
        // Handle undefined case
        if (!dateStr) {
            return { year: 0, month: 0, day: 0 };
        }
        
        // Extract year, month, day from "2025.08.01"
        const match = dateStr.match(/(\d{4})\.(\d{2})\.(\d{2})/);
        if (!match) {
            throw new Error('Invalid date format. Expected format: YYYY.MM.DD');
        }
        
        const year = parseInt(match[1], 10);
        const month = parseInt(match[2], 10);
        const day = parseInt(match[3], 10);
        
        return { year, month, day};
    };
    
    const date1 = parseDate(startDate);
    const date2 = parseDate(endDate);
    
    // Handle case where both dates are undefined (return empty string)
    if (date1.year === 0 && date1.month === 0 && date1.day === 0 && 
        date2.year === 0 && date2.month === 0 && date2.day === 0) {
        return '';
    }
    
    // Handle case where only startDate exists (no endDate)
    if (date1.year !== 0 && date1.month !== 0 && date1.day !== 0 && 
        date2.year === 0 && date2.month === 0 && date2.day === 0) {
        return `${date1.year}년 ${date1.month}월 ${date1.day}일 부터 상시`;
    }
    
    // Format the date range text directly
    return `${date1.year} 년 ${date1.month} 월 ${date1.day}일 부터 ${date2.year}년 ${date2.month}월 ${date2.day}일 까지`;
}